module.exports = __webpack_public_path__ + "assets/search-mobile-orange-d6024f5e508c906973abc92746b0d178.svg";